import {useMemo} from 'react';

import {useLatestPublishingPipelineQuery} from '~api/automl.queries';

/**
 * Shared hook that determines whether the Deploy page should be considered available.
 * Currently, this is true when there is at least one publishing pipeline.
 *
 * Wrapped in a hook so multiple components can reuse the same logic without
 * duplicating the query/conditions.
 */
export function useIsDeployAvailable() {
  const {data: publishingPipelineStatus, isLoading} = useLatestPublishingPipelineQuery({
    allModels: true,
  });

  const isDeployAvailable = useMemo(() => {
    if (isLoading) return false;
    return !!publishingPipelineStatus;
  }, [isLoading, publishingPipelineStatus]);

  return {isDeployAvailable, isLoading};
}
